import React from 'react'
import { Container, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
// import Logo from '../components/Logo/Logo';
import ClientInfo from '../components/Clients/ClientInfo';
import ClientTeam from '../components/Clients/ClientTeam';
import ClientDailyStatus from '../components/Clients/ClientDailyStatus';
import ClientTimeWorkflow from '../components/Clients/ClientTimeWorkflow';
import ClientMeetings from '../components/Clients/ClientMeetings';
import ClientTraining from '../components/Clients/ClientTraining';
import PermissionWrapper from '../auth/PermissionWrapper';
import classnames from 'classnames';

class Client extends React.Component {

    constructor(props) {
        super(props);

        this.increment = 10;
        this.clientId = this.props.clientId != null ? this.props.clientId : parseInt(this.props.location.pathname.split('/')[2]);

        this.state = {
            activeTab: 2,
            clientReports: {},
            files: [],
            employees: [],
            teams: [],
            isLoaded: false,
            filesLoaded: false,
            loadedPageTimestamp: new Date().getTime(),
            loadedServerTimestamp: 0,
            selectedClientReportId: 0,
            showing: this.increment,
            uploadSuccess: false,
            saveSuccess: false,
            newEmployee: { ...this.blankEmployee },
            editEmployee: { ...this.blankEmployee },
            filters: {
                dateMin: null,
                dateMax: null,
                securitiesMin: null,
                securitiesMax: null,
                accountsMin: null,
                accountsMax: null,
                reconMin: null,
                reconMax: null,
                unreconMin: null,
                unreconMax: null,
                timer: null,
                timerNone: false,
                timerProgress: false,
                timerFinished: false
            },
        };
    }

    componentDidMount = () => {
        this.props.log('Client.js/componentDidMount');
        this.getClientReports();
        this.getFiles();
        this.getEmployees();
        this.getTeams();
        this.setState(prevState => {
            const sel = prevState;
            if (sel.clientReports != null && sel.clientReports.reports != null) {
                sel.clientReports.reports.forEach(report => {
                    const timeTrackingIndex = report.timeTracking != null ? report.timeTracking.findIndex(tt => tt.endTimestamp == null) : -1;
                    if (timeTrackingIndex > -1) {
                        const timeOffset = this.state.loadedServerTimestamp - this.state.loadedPageTimestamp;
                        const beginTimestamp = new Date(report.timeTracking.filter(timer => timer.endTimestamp == null)[0].beginTimestamp);
                        const timeDiff = new Date().getTime() - beginTimestamp.getTime() + timeOffset;
                        report.timeTracking[timeTrackingIndex].timeDiff = timeDiff;
                    }
                })
            }
            return sel
        });
    }

    componentWillUnmount() {
        this.props.log('Client.js/componentWillUnmount');
        this.isUnmounted = true;
    }

    getTeams = () => {
        this.props.log('Client.js/getTeams');
        fetch('/api/teams/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        teams: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFiles = () => {
        this.props.log('Client.js/getFiles');
        // return;
        fetch('/api/files/' + this.clientId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        filesLoaded: true,
                        files: results.data
                    });
                } else {
                    this.props.addToast('Unable to load files.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getEmployees = () => {
        this.props.log('Client.js/getEmployees');
        fetch('/api/employees/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        employees: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getClientReports = () => {
        this.props.log('Client.js/getClientReports');
        this.setState({
            loadedPageTimestamp: new Date().getTime()
        }, () => {
            fetch('/api/clientReports/' + this.clientId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (this.isUnmounted) return;
                    if (results.success) {
                        this.setState((prevState, props) => {
                            let return_value = {
                                'clientReports': results.data,
                                isLoaded: true,
                                loadedServerTimestamp: results.timestamp,
                            };
                            if (this.state.selectedClientReportId > 0) {
                                return_value.selectedReport = return_value.clientReports.reports.filter(report => report.id === this.state.selectedClientReportId)[0];
                            }
                            return return_value;
                        });
                    } else {
                        this.props.addToast('Company info is not available.', 5, 'danger')
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        });
    }

    selectReport = (report) => {
        this.props.log('Client.js/selectReport (report)', report);
        this.setState({
            selectedClientReportId: report.id === this.state.selectedClientReportId ? 0 : report.id,
            selectedReport: report
        });
    }


    handleReconciliationTextInputChange = (e) => {
        this.props.log('Client.js/handleReconciliationTextInputChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.setState(prevState => {
            const sel = prevState;
            const inputArr = e.target.name.split('_');
            const reconciliationsIndex = sel.selectedReport.reconciliations.findIndex(item => item.outages[0].id === parseInt(inputArr[1]));
            const outageIndex = sel.selectedReport.reconciliations[reconciliationsIndex].outages.findIndex(item => item.id === parseInt(inputArr[2]));
            sel.selectedReport.reconciliations[reconciliationsIndex].outages[outageIndex][inputArr[0]] = e.target.value;
            return sel
        });
    }

    handleTimeTracking = (state, report) => {
        this.props.log('Client.js/handleTimeTracking (state, report)', state, report);
        if (state === 'begin') {
            fetch('/api/clientTimeTracking/', {
                method: 'POST',
                body: JSON.stringify({
                    clientReportId: report.id,
                    userAuth0: this.props.user,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(() => {
                    this.getClientReports();
                });
        } else if (state === 'end' && report.timeTracking.endTimestamp == null) {
            fetch('/api/clientTimeTracking/' + report.timeTracking.id, {
                method: 'PUT',
                body: JSON.stringify({
                    userAuth0: this.props.user,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(() => {
                    this.getClientReports();
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        }
    }

    handleTimeTrackingInput = (report) => {
        this.props.log('Client.js/handleTimeTrackingInput (report)', report);
        if (report.timeTracking.id == null) {
            fetch('/api/clientTimeTrackingInput/', {
                method: 'POST',
                body: JSON.stringify({
                    clientReportId: report.id,
                    beginTimestamp: report.timeTracking.beginTimestamp,
                    endTimestamp: report.timeTracking.endTimestamp,
                    userAuth0: this.props.user,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(() => {
                    this.getClientReports();
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        } else {
            fetch('/api/clientTimeTrackingInput/' + report.timeTracking.id, {
                method: 'PUT',
                body: JSON.stringify({
                    clientTimeTrackingId: report.timeTracking.id,
                    beginTimestamp: report.timeTracking.beginTimestamp,
                    endTimestamp: report.timeTracking.endTimestamp,
                    userAuth0: this.props.user,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(() => {
                    this.getClientReports();
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        }
    }

    submitReconciliationNote = (index) => {
        this.props.log('Client.js/submitReconciliationNote (index)', index);
        index = this.state.selectedReport.reconciliations.findIndex(item => item.outages[0].id === parseInt(index));
        const reconciliationData = this.state.selectedReport.reconciliations[index];
        fetch('/api/clientReconciliationsNote/' + this.state.selectedReport.id, {
            method: 'PUT',
            body: JSON.stringify({
                account: reconciliationData.account,
                reconNotes: reconciliationData.outages[0].reconNotes,
                adjustReconAuth: this.props.user,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                this.getClientReports();
                // this.props.addToast('Reconciliation submitted successfully.', 5, 'success')
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    submitReconciliation = (index) => {
        this.props.log('Client.js/submitReconciliation (index)', index);
        index = this.state.selectedReport.reconciliations.findIndex(item => item.outages[0].id === parseInt(index));
        const reconciliationData = this.state.selectedReport.reconciliations[index];
        fetch('/api/clientReconciliations/' + this.state.selectedReport.id, {
            method: 'PUT',
            body: JSON.stringify({
                account: reconciliationData.account,
                reconNotes: reconciliationData.outages[0].reconNotes,
                adjustReconAuth: this.props.user,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                this.getClientReports();
                // this.props.addToast('Reconciliation submitted successfully.', 5, 'success')
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    submitReconciliationOutage = (index, outageIndex) => {
        this.props.log('Client.js/submitReconciliation (index, outageIndex)', index, outageIndex);
        index = this.state.selectedReport.reconciliations.findIndex(item => item.outages[0].id === parseInt(index));
        const reconciliationData = this.state.selectedReport.reconciliations[index];
        outageIndex = this.state.selectedReport.reconciliations[index].outages.findIndex(item => item.id === parseInt(outageIndex));
        const reconciliationOutageData = outageIndex != null ? this.state.selectedReport.reconciliations[index].outages[outageIndex] : null;
        fetch('/api/clientReconciliationOutage/' + this.state.selectedReport.id, {
            method: 'PUT',
            body: JSON.stringify({
                account: reconciliationData.account,
                security: reconciliationOutageData.security,
                securityType: reconciliationOutageData.securityType,
                adjustReconNotes: reconciliationOutageData.adjustReconNotes,
                adjustReconAuth: this.props.user,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                this.getClientReports();
                // this.props.addToast('Reconciliation submitted successfully.', 5, 'success')
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    submitReconciliationOutageNote = (index, outageIndex) => {
        this.props.log('Client.js/submitReconciliation (index, outageIndex)', index, outageIndex);
        index = this.state.selectedReport.reconciliations.findIndex(item => item.outages[0].id === parseInt(index));
        const reconciliationData = this.state.selectedReport.reconciliations[index];
        outageIndex = this.state.selectedReport.reconciliations[index].outages.findIndex(item => item.id === parseInt(outageIndex));
        const reconciliationOutageData = outageIndex != null ? this.state.selectedReport.reconciliations[index].outages[outageIndex] : null;
        fetch('/api/clientReconciliationOutageNote/' + this.state.selectedReport.id, {
            method: 'PUT',
            body: JSON.stringify({
                account: reconciliationData.account,
                security: reconciliationOutageData.security != null ? reconciliationOutageData.security : '',
                securityType: reconciliationOutageData.securityType != null ? reconciliationOutageData.securityType : '',
                adjustReconNotes: reconciliationOutageData.adjustReconNotes,
                adjustReconAuth: this.props.user,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                this.getClientReports();
                // this.props.addToast('Reconciliation submitted successfully.', 5, 'success')
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleUpload = (e, reportId, type) => {
        this.props.log('Client.js/handleUpload (e, reportId, type)', e, reportId, type);
        let f = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => {
            let file = {
                name: f.name,
                type: f.type,
                size: f.size,
                base64: reader.result,
            };
            this.uploadFile(file, reportId, type);
        }
    }

    uploadFile = (file, reportId, type) => {
        this.props.log('Client.js/uploadFiles (file, reportId, type)', file, reportId, type);
        const json_request = JSON.stringify({
            clientId: this.clientId,
            reportId: reportId,
            auth0: this.props.user,
            type: type,
            filename: file.name,
            filesize: file.size,
            filetype: file.type,
            data: file.base64,
            meta: null
        });
        fetch('/api/files/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: true,
                    }, () => {
                        this.getFiles();
                        this.props.addToast('File uploaded successfully.', 5, 'success')
                    })
                    :
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: false,
                    }, () => this.props.addToast('Unable to upload file.', 5, 'danger'))
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    handleUpdateClientInfo = (id, obj) => {
        this.props.log('Client.js/handleUpdateClientInfo (id, obj)', id, obj);
        this.setState({
            clientReports: { ...this.state.clientReports, ...obj }
        }, () => {
            fetch('/api/clientInfo/' + id, {
                method: 'PUT',
                body: JSON.stringify({
                    info: this.state.clientReports.info,
                    team: this.state.clientReports.team,
                    employeePrimaryContact: this.state.clientReports.employeePrimaryContact,
                    employeeProcessor: this.state.clientReports.employeeProcessor,
                    employeeSecondaryContact: this.state.clientReports.employeeSecondaryContact,
                    meetingFrequency: this.state.clientReports.meetingFrequency
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(this.getClientReports())
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    }

    changeTab = () => {
        this.props.log('Client.js/changeTab');
        this.setState({
            uploadSuccess: false,
            saveSuccess: false,
        })
    }

    changeFilter = (e) => {
        this.props.log('Client.js/changeFilter (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.setState(prevState => {
            const sel = prevState;
            sel.filters[e.target.name] = (e.target.value == null || e.target.value === '') ? null : e.target.value;
            return sel;
        });
    }

    calculateDuration = (workflowIndex, nameArray, value) => {
        this.props.log('Client.js/calculateDuration (workflowIndex,nameArray,value)', workflowIndex, nameArray, this.state.clientReports.workflows[workflowIndex].tasks, value);
        let duration = '';
        let tt = null;
        if (nameArray.length === 2) {
            tt = this.state.clientReports.workflows[workflowIndex].estimates[0]//[nameArray[0]];
        } else if (nameArray.length === 3) {
            tt = this.state.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates[0]//[nameArray[0]];
        }
        if (tt.estimatedBeginTime !== '' && tt.estimatedEndTime !== '' && tt.estimatedBeginTime != null && tt.estimatedEndTime != null) {
            const [estimatedBeginHours, estimatedBeginMinutes] = tt.estimatedBeginTime.split(':').map(item => parseInt(item));
            const [estimatedEndHours, estimatedEndMinutes] = tt.estimatedEndTime.split(':').map(item => parseInt(item));
            duration = Math.max(((((estimatedEndHours * 60) + estimatedEndMinutes) - ((estimatedBeginHours * 60) + estimatedBeginMinutes)) / 60), 0).toFixed(2);
        } else {
            // return '';
        }
        this.setState((prevState) => {
            let sel = { ...prevState };
            if (nameArray.length === 2) {
                if (duration !== '') sel.clientReports.workflows[workflowIndex].estimates[0].estimatedDuration = duration;
                sel.clientReports.workflows[workflowIndex].estimates[0].userPreventSetDuration = ((tt.estimatedBeginTime !== '' && tt.estimatedBeginTime != null) || (tt.estimatedEndTime !== '' && tt.estimatedEndTime != null)) ? true : false;
                sel.clientReports.workflows[workflowIndex].estimates[0].userSetDuration = (nameArray[0] === 'estimatedDuration' && value > 0) ? true : false;
            } else if (nameArray.length === 3) {
                if (duration !== '') sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates[0].estimatedDuration = duration;
                sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates[0].userPreventSetDuration = ((tt.estimatedBeginTime !== '' && tt.estimatedBeginTime != null) || (tt.estimatedEndTime !== '' && tt.estimatedEndTime != null)) ? true : false;
                sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates[0].userSetDuration = (nameArray[0] === 'estimatedDuration' && value > 0) ? true : false;
            }
            return sel;
        })
    }

    changeWorkflowEstimate = (e) => {
        this.props.log('Client.js/changeWorkflowEstimate (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        const nameArray = e.target.name.split('_');
        const workflowIndex = this.state.clientReports.workflows.findIndex(item => item.id === parseInt(nameArray[1]));
        this.setState(prevState => {
            const sel = prevState;
            if (nameArray.length === 2) {
                if (sel.clientReports.workflows[workflowIndex].estimates == null) {
                    sel.clientReports.workflows[workflowIndex].estimates = [{}]
                }
                sel.clientReports.workflows[workflowIndex].estimates[0][nameArray[0]] = (e.target.value == null || e.target.value === '') ? null : e.target.value;
                sel.clientReports.workflows[workflowIndex].estimates[0].changed = true;
            } else if (nameArray.length === 3) {
                if (sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates == null) {
                    sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates = [{}]
                }
                sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates[0][nameArray[0]] = (e.target.value == null || e.target.value === '') ? null : e.target.value;
                sel.clientReports.workflows[workflowIndex].tasks[parseInt(nameArray[2])].estimates[0].changed = true;
            }
            return sel;
        }, () => this.calculateDuration(workflowIndex, nameArray, e.target.value));
    }

    formatAMPM = (date) => {
        this.props.info('Client.js/formatAMPM (date)', date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    submitEstimate = (workflowId, taskIndex) => {
        this.props.log('Client.js/submitEstimate (workflowId, taskIndex)', workflowId, taskIndex);
        const workflowIndex = this.state.clientReports.workflows.findIndex(item => item.id === parseInt(workflowId));
        fetch('/api/workflow-' + ((taskIndex != null && parseInt(taskIndex) >= 0) ? 'task-' : '') + 'estimates', {
            method: 'PUT',
            body: JSON.stringify({
                workflowId: this.state.clientReports.workflows[workflowIndex].id,
                workflowTaskId: (taskIndex != null && parseInt(taskIndex) >= 0) ? this.state.clientReports.workflows[workflowIndex].tasks[taskIndex].id : null,
                workflowTaskOrder: (taskIndex != null && parseInt(taskIndex) >= 0) ? this.state.clientReports.workflows[workflowIndex].tasks[taskIndex].estimates[0].order : null,
                clientId: this.state.clientReports.clientId,
                active: 1,
                estimatedBeginTime: ((taskIndex != null && parseInt(taskIndex) >= 0) ?
                    this.state.clientReports.workflows[workflowIndex].tasks[taskIndex].estimates[0].estimatedBeginTime
                    : this.state.clientReports.workflows[workflowIndex].estimates[0].estimatedBeginTime),
                estimatedEndTime: ((taskIndex != null && parseInt(taskIndex) >= 0) ?
                    this.state.clientReports.workflows[workflowIndex].tasks[taskIndex].estimates[0].estimatedEndTime
                    : this.state.clientReports.workflows[workflowIndex].estimates[0].estimatedEndTime),
                estimatedDuration: ((taskIndex != null && parseInt(taskIndex) >= 0) ?
                    this.state.clientReports.workflows[workflowIndex].tasks[taskIndex].estimates[0].estimatedDuration
                    : this.state.clientReports.workflows[workflowIndex].estimates[0].estimatedDuration),
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) this.getClientReports();
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    render = () => {
        this.props.info('Client.js/render');
        if (this.state.isLoaded && this.state.filesLoaded) {
            return (
                <Container fluid>
                    <Row>
                        <Col md={12}><h2>{this.state.clientReports.name}
                            {this.state.clientReports.customerNumber != null && this.state.clientReports.customerNumber !== '' ?
                                <> ({this.state.clientReports.customerNumber})</> : <></>
                            }</h2></Col>
                    </Row>
                    <Row>
                        {/* <Col md={3}>
                            <Logo {...this.props} clientId={this.clientId} files={this.state.files.filter(file => file.type === 'logo')} getFiles={this.getFiles} />
                        </Col> */}
                        <Col md={12}>
                            <Nav tabs className="pb-0 px-4">
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Daily Status">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 1 })}
                                            onClick={() => { this.setState({ activeTab: 1 }); this.changeTab(); }}>
                                            Daily Status
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Daily Workflow">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 2 })}
                                            onClick={() => { this.setState({ activeTab: 2 }); this.changeTab(); }}>
                                            Daily Workflow
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Monthly Workflow">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 3 })}
                                            onClick={() => { this.setState({ activeTab: 3 }); this.changeTab(); }}>
                                            Monthly Workflow
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Quarterly Workflow">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 7 })}
                                            onClick={() => { this.setState({ activeTab: 7 }); this.changeTab(); }}>
                                            Quarterly Workflow
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Training">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 8 })}
                                            onClick={() => { this.setState({ activeTab: 8 }); this.changeTab(); }}>
                                            Training
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Company Info">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 4 })}
                                            onClick={() => { this.setState({ activeTab: 4 }); this.changeTab(); }}>
                                            Company Info
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Meetings">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 6 })}
                                            onClick={() => { this.setState({ activeTab: 6 }); this.changeTab(); }}>
                                            Customer Meetings
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client CSSI Personnel">
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 5 })}
                                            onClick={() => { this.setState({ activeTab: 5 }); this.changeTab(); }}>
                                            CSSI Personnel
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab} className="p-2">
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Daily Status">
                                    <TabPane tabId={1}>
                                        <ClientDailyStatus
                                            {...this.props}
                                            changeFilter={this.changeFilter}
                                            handleReconciliationTextInputChange={this.handleReconciliationTextInputChange}
                                            submitReconciliation={this.submitReconciliation}
                                            submitReconciliationNote={this.submitReconciliationNote}
                                            submitReconciliationOutage={this.submitReconciliationOutage}
                                            submitReconciliationOutageNote={this.submitReconciliationOutageNote}
                                            handleUpload={this.handleUpload}
                                            selectReport={this.selectReport}
                                            changeTab={this.changeTab}
                                            filters={this.state.filters}
                                            clientReports={this.state.clientReports}
                                            showing={this.state.showing}
                                            selectedClientReportId={this.state.selectedClientReportId}
                                            selectedReport={this.state.selectedReport}
                                            files={this.state.files}
                                            loadedServerTimestamp={this.state.loadedServerTimestamp}
                                            loadedPageTimestamp={this.state.loadedPageTimestamp}
                                            handleTimeTracking={this.handleTimeTracking}
                                            handleTimeTrackingInput={this.handleTimeTrackingInput}
                                            formatAMPM={this.formatAMPM}
                                            getClientReports={this.getClientReports}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Daily Workflow">
                                    <TabPane tabId={2}>
                                        <ClientTimeWorkflow
                                            {...this.props}
                                            time={24}
                                            daily={true}
                                            requireTimes={true}
                                            getClientReports={this.getClientReports}
                                            changeWorkflowEstimate={this.changeWorkflowEstimate}
                                            submitEstimate={this.submitEstimate}
                                            clientReports={this.state.clientReports}
                                            employees={this.state.employees}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Monthly Workflow">
                                    <TabPane tabId={3}>
                                        <ClientTimeWorkflow
                                            {...this.props}
                                            time={730}
                                            daily={true}
                                            requireTimes={false}
                                            getClientReports={this.getClientReports}
                                            changeWorkflowEstimate={this.changeWorkflowEstimate}
                                            submitEstimate={this.submitEstimate}
                                            clientReports={this.state.clientReports}
                                            employees={this.state.employees}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Quarterly Workflow">
                                    <TabPane tabId={7}>
                                        <ClientTimeWorkflow
                                            {...this.props}
                                            time={2190}
                                            daily={true}
                                            requireTimes={false}
                                            getClientReports={this.getClientReports}
                                            changeWorkflowEstimate={this.changeWorkflowEstimate}
                                            submitEstimate={this.submitEstimate}
                                            clientReports={this.state.clientReports}
                                            employees={this.state.employees}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Training">
                                    <TabPane tabId={8}>
                                        <ClientTraining
                                            {...this.props}
                                            clientId={this.state.clientReports.clientId}
                                            clientInfo={this.state.clientReports.info}
                                            clientData={this.state.clientReports}
                                            handleUpload={this.handleUpload}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Company Info">
                                    <TabPane tabId={4}>
                                        <ClientInfo
                                            {...this.props}
                                            clientId={this.state.clientReports.clientId}
                                            clientInfo={this.state.clientReports.info}
                                            handleUpdateClientInfo={this.handleUpdateClientInfo}
                                            clientData={this.state.clientReports}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client Meetings">
                                    <TabPane tabId={6}>
                                        <ClientMeetings
                                            {...this.props}
                                            clientId={this.state.clientReports.clientId}
                                            clientInfo={this.state.clientReports.info}
                                            handleUpdateClientInfo={this.handleUpdateClientInfo}
                                            clientData={this.state.clientReports}
                                            employees={this.state.employees}
                                            getClientReports={this.getClientReports}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                                <PermissionWrapper refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission="Client CSSI Personnel">
                                    <TabPane tabId={5}>
                                        <ClientTeam
                                            {...this.props}
                                            clientId={this.state.clientReports.clientId}
                                            clientInfo={this.state.clientReports.info}
                                            handleUpdateClientInfo={this.handleUpdateClientInfo}
                                            clientData={this.state.clientReports}
                                            employees={this.state.employees}
                                            teams={this.state.teams}
                                        />
                                    </TabPane>
                                </PermissionWrapper>
                            </TabContent>

                        </Col>
                    </Row>
                </Container>
            )
        } else {
            return (<h2>Loading...</h2>)
        }
    }
}

export default Client;